'use client';

import { Toaster as Sonner, toast } from 'sonner';
import { CheckCircle, XCircle, WarningCircle, Info } from '@phosphor-icons/react';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      position="top-center"
      expand={true}
      richColors
      gap={8}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: `
            group flex items-center gap-3 w-full px-4 py-3.5
            rounded-card border border-[var(--border-default)]/50
            bg-[var(--surface-primary)]/95 backdrop-blur-xl
            shadow-float
            data-[type=success]:border-[var(--success)]/20
            data-[type=error]:border-[var(--error)]/20
            data-[type=warning]:border-[var(--warning)]/20
            data-[type=info]:border-[var(--primary)]/20
          `,
          title: 'text-sm font-medium text-[var(--text-primary)]',
          description: 'text-xs text-[var(--text-secondary)]',
          actionButton: `
            px-3 py-1.5 rounded-pill text-xs font-medium
            bg-[var(--primary)] text-white
            hover:bg-[var(--primary-hover)] transition-colors
          `,
          cancelButton: `
            px-3 py-1.5 rounded-pill text-xs font-medium
            bg-[var(--surface-secondary)] text-[var(--text-secondary)]
            hover:bg-[var(--surface-tertiary)] transition-colors
          `,
          closeButton: `
            opacity-0 group-hover:opacity-100 transition-opacity
            text-[var(--text-tertiary)] hover:text-[var(--text-primary)]
          `,
        },
      }}
      icons={{
        success: (
          <div className="flex items-center justify-center w-8 h-8 rounded-pill bg-[var(--success)]/15">
            <CheckCircle className="h-5 w-5 text-[var(--success)]" weight="fill" />
          </div>
        ),
        error: (
          <div className="flex items-center justify-center w-8 h-8 rounded-pill bg-[var(--error)]/15">
            <XCircle className="h-5 w-5 text-[var(--error)]" weight="fill" />
          </div>
        ),
        warning: (
          <div className="flex items-center justify-center w-8 h-8 rounded-pill bg-[var(--warning)]/15">
            <WarningCircle className="h-5 w-5 text-[var(--warning)]" weight="fill" />
          </div>
        ),
        info: (
          <div className="flex items-center justify-center w-8 h-8 rounded-pill bg-[var(--primary)]/15">
            <Info className="h-5 w-5 text-[var(--primary)]" weight="fill" />
          </div>
        ),
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
